import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { EloShellLarge } from './EloShellLarge';
import { EloShellSmall } from './EloShellSmall';
import ErrorBoundary from '@/utils/ErrorBoundary';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import { setSentryUser } from '@/main';
import { ChatwootProvider } from '@/contexts/ChatWootContext';

export function EloShell(props: any) {
  const theme = useMantineTheme();
  const isSmall = useMediaQuery(`(max-width: ${theme.breakpoints.sm}`);
  const Comp = isSmall ? EloShellSmall : EloShellLarge;

  const { user } = useAuth0();
  const hasSetUserId = useRef(false);

  useEffect(() => {
    if (user && !hasSetUserId.current) {
      ReactGA.set({ userId: user.sub });
      if (user.email && user.name) {
        setSentryUser(user.name, user.email);
      }
      hasSetUserId.current = true;
    }
  }, [user]);

  return (
    <>
      <ErrorBoundary>
        <ChatwootProvider>
          <Comp {...props} />
        </ChatwootProvider>
      </ErrorBoundary>
    </>
  );
}
